/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LightIcon = ({ width = 24, height = 24, hidden = false, title = 'Light' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="18" cy="18" r="7.9" />
    <rect height="6" rx=".5" ry=".5" width="3.6" x="16.2" />
    <rect height="6" rx=".5" ry=".5" width="3.6" x="16.2" y="30" />
    <rect height="3.6" rx=".5" ry=".5" width="6" y="16.2" />
    <rect height="3.6" rx=".5" ry=".5" width="6" x="30" y="16.2" />
    <rect
      height="3.6"
      rx=".5"
      ry=".5"
      transform="rotate(-45 29.02 7.02)"
      width="6"
      x="26.02"
      y="5.22"
    />
    <rect
      height="3.6"
      rx=".5"
      ry=".5"
      transform="rotate(-45 7.02 29.02)"
      width="6"
      x="4.02"
      y="27.22"
    />
    <rect height="6" rx=".5" ry=".5" transform="rotate(-45 7 7)" width="3.6" x="5.2" y="4" />
    <rect
      height="6"
      rx=".5"
      ry=".5"
      transform="rotate(-45 28.98 28.98)"
      width="3.6"
      x="27.18"
      y="25.98"
    />
  </svg>`;
};
